import React from 'react';
import IconInstagram from './IconInstagram';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconIstagramShare: React.FC<IconProps> = ({ width = 22, height = 22, color = '#000' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 22 22"
            fill="none"
        >
            <g clip-path="url(#clip0_10468_174)">
                <path
                    d="M20.8297 1.34813C20.603 1.03358 20.2395 0.860352 19.8062 0.860352C19.6028 0.860352 19.3847 0.898689 19.1581 0.974275L1.60484 6.82534C0.998537 7.02742 0.580656 7.44043 0.458307 7.95853C0.335958 8.47666 0.524984 9.03306 0.97693 9.48513C1.02111 9.52935 1.07191 9.56644 1.12746 9.5951L8.51762 13.4045L12.3272 20.7947C12.3558 20.8502 12.3929 20.901 12.4371 20.9452C12.8003 21.3084 13.2191 21.5004 13.6485 21.5005H13.6486C14.2987 21.5005 14.8538 21.047 15.0969 20.3173L20.9481 2.76412C21.132 2.21208 21.09 1.70922 20.8297 1.34813ZM1.63532 8.23648C1.65846 8.1384 1.79334 8.03734 1.98725 7.97267L18.6479 2.41912L8.8512 12.2158L1.77472 8.56809C1.66813 8.44353 1.61544 8.32065 1.63532 8.23648ZM13.9495 19.9349C13.8921 20.1071 13.783 20.2911 13.6486 20.2911C13.5671 20.2911 13.4606 20.2384 13.3542 20.1474L9.70636 13.0709L19.5033 3.27403L13.9495 19.9349Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_10468_174">
                    <rect
                        width="20.6401"
                        height="20.6401"
                        fill={color}
                        transform="translate(0.421875 0.860352)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconIstagramShare;
